import React from 'react'
import Slider from "react-slick";
import { toolsTech } from '../../utils/toolsTechData'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Tools = () => {
  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 1500,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200, // below 1200px
        settings: {
          slidesToShow: 8,
        }
      },
      {
        breakpoint: 992, // below 992px (tablet)
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 768, // below 768px (mobile)
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 576, // below 576px (small mobile)
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  };

  return (
    <div className='bg-body-secondary p-4 mt-5'>
        <div className='ToolsHeader'>
          <h1 className='fw-bolder'><span className='fw-medium fst-italic text-primary'>Tools</span> and</h1>
          <h1 className='fw-bolder'><span className='fw-medium fst-italic text-primary'>Technologies</span></h1>
        </div>
        <div className='toolsWrapper pt-2 ps-4 pe-4'>
          {toolsTech.map(tt => {
            return(
              <div className='toolsSection'>
                <h1 className='pt-5 fs-3 fw-medium text-secondary'>{tt.title}</h1>
                <div className='toolsListWrapper p-2 row justify-content-center gap-3'>
                  <Slider {...settings}>
                    {tt.tools.map((tool, index) => {
                      return(
                        <div key={index} className="d-flex flex-column align-items-center">
                        <div className="card border-0" style={{ width: '7rem' }}>
                          <img src={tool.image} className="card-img-top" alt=""/>
                          <div className="card-body">
                            <p className="card-text fs-6 fw-medium mb-0">{tool.name}</p>
                          </div>
                        </div>
                        </div>
                      )
                    })}
                  </Slider>
                </div>
              </div>
            )
          })}
        </div>
    </div>
  )
}

export default Tools
